module.exports = __webpack_public_path__ + "angular-icon.svg?4d481192bc14107cb83ee8428d80ba2b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/skill-icons/angular-icon.svg
// module id = 52
// module chunks = 0